function cftMatchVariant(variants, selected, currentId) {
  if (!selected.length) return variants.find(variant => String(variant.id) === String(currentId)) || variants[0] || null;
  return variants.find(variant => variant.options.length === selected.length &&
    selected.every((value, index) => variant.options[index] === value)) || null;
}

function cftPurchaseState(data, variant, adding = false) {
  if (adding) return { disabled: true, label: 'Adding…' };
  if (!variant) return { disabled: true, label: 'Unavailable' };
  if (!variant.available) return { disabled: true, label: 'Sold out' };
  if (data.requiresPlan) return { disabled: true, label: 'Purchase options unavailable' };
  if (!data.allowed) return { disabled: true, label: 'Coming soon' };
  return { disabled: false, label: data.buyLabel || 'Add to bag' };
}

function cftVariantMediaIndex(mediaIds, mediaId) {
  const index = mediaIds.findIndex(id => Number(id) === Number(mediaId));
  return index >= 0 ? index : mediaIds.length ? 0 : -1;
}

if (typeof module !== 'undefined') module.exports = { cftMatchVariant, cftPurchaseState, cftVariantMediaIndex };

if (typeof document !== 'undefined') {
  const initPdp = root => {
    if (root.dataset.pdpReady) return;
    root.dataset.pdpReady = 'true';
    const rail = root.querySelector('[data-pdp-media-rail]');
    const slides = [...rail.children];
    if (!slides.length) {
      root.querySelector('.cft-pdp-gallery-nav').hidden = true;
      root.querySelector('[data-pdp-zoom]').hidden = true;
    }
    const thumbs = [...root.querySelectorAll('[data-pdp-thumb]')];
    let active = 0;
    const reduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const showMedia = index => {
      active = Math.max(0, Math.min(slides.length - 1, index));
      const slide = slides[active];
      if (!slide) return;
      rail.scrollTo({ left: slide.offsetLeft - rail.offsetLeft, behavior: reduced() ? 'auto' : 'smooth' });
    };
    const updateMedia = () => {
      if (!slides.length) return;
      active = Math.max(0, Math.min(slides.length - 1, Math.round(rail.scrollLeft / rail.clientWidth)));
      thumbs.forEach((thumb, index) => thumb.setAttribute('aria-pressed', String(index === active)));
      root.querySelector('[data-pdp-media-counter]').textContent = `${active + 1} / ${slides.length}`;
      root.querySelector('[data-pdp-prev]').disabled = active === 0;
      root.querySelector('[data-pdp-next]').disabled = active === slides.length - 1;
      slides.forEach((slide, index) => {
        if (index !== active) slide.querySelectorAll('video').forEach(video => video.pause());
      });
    };
    thumbs.forEach(thumb => thumb.addEventListener('click', () => showMedia(Number(thumb.dataset.pdpThumb))));
    root.querySelector('[data-pdp-prev]').addEventListener('click', () => showMedia(active - 1));
    root.querySelector('[data-pdp-next]').addEventListener('click', () => showMedia(active + 1));
    rail.addEventListener('scroll', updateMedia, { passive: true });
    rail.addEventListener('keydown', event => {
      if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
      event.preventDefault();
      showMedia(active + (event.key === 'ArrowRight' ? 1 : -1));
    });
    updateMedia();
    const dialog = root.querySelector('[data-pdp-zoom-dialog]');
    root.querySelector('[data-pdp-zoom]').addEventListener('click', () => {
      const image = slides[active]?.querySelector('img');
      if (!image) return;
      const large = dialog.querySelector('img');
      large.src = image.currentSrc || image.src;
      large.alt = image.alt;
      large.width = image.naturalWidth || 1200;
      large.height = image.naturalHeight || 1500;
      dialog.showModal();
    });
    dialog.querySelector('button').addEventListener('click', () => dialog.close());
    const tabs = [...root.querySelectorAll('[data-pdp-tab]')];
    const panels = [...root.querySelectorAll('[data-pdp-panel]')];
    const selectTab = index => {
      tabs.forEach((tab, i) => {
        tab.setAttribute('aria-selected', String(i === index));
        tab.tabIndex = i === index ? 0 : -1;
      });
      panels.forEach((panel, i) => {
        panel.hidden = i !== index;
        if (i === index) {
          const body = panel.querySelector('[data-pdp-tabbody]');
          const more = panel.querySelector('[data-pdp-more]');
          more.hidden = body.scrollHeight <= body.clientHeight + 1 && !body.classList.contains('is-expanded');
        }
      });
    };
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => selectTab(index));
      tab.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const target = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 :
          (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
        selectTab(target);
        tabs[target].focus();
      });
    });
    root.querySelectorAll('[data-pdp-more]').forEach(button => button.addEventListener('click', () => {
      const body = button.parentElement.querySelector('[data-pdp-tabbody]');
      const expanded = body.classList.toggle('is-expanded');
      button.setAttribute('aria-expanded', String(expanded));
      button.textContent = expanded ? 'View less' : 'View more';
    }));
    if (tabs.length) selectTab(0);
    const dataNode = root.querySelector('[data-pdp-variants]');
    if (dataNode) {
      const data = JSON.parse(dataNode.textContent);
      const form = root.querySelector('.cft-pdp-form');
      const buy = form.querySelector('[data-pdp-buy]');
      const status = form.querySelector('[data-pdp-status]');
      const variantControl = form.querySelector('[data-pdp-variant-id]');
      const quantity = form.querySelector('[data-pdp-quantity]');
      const dynamic = form.querySelector('[data-pdp-dynamic]');
      let adding = false;
      const selectedVariant = () => cftMatchVariant(data.variants,
        [...form.querySelectorAll('[data-pdp-option]')].map(field => field.querySelector('input:checked')?.value), variantControl.value);
      const updateBuy = () => {
        const state = cftPurchaseState(data, selectedVariant(), adding);
        buy.disabled = state.disabled;
        buy.textContent = state.label;
        if (dynamic) dynamic.hidden = state.disabled;
        const stickyBuy = root.querySelector('[data-pdp-return]');
        if (stickyBuy) { stickyBuy.disabled = state.disabled; stickyBuy.textContent = state.label; }
      };
      const updateVariant = () => {
        const variant = selectedVariant();
        updateBuy();
        variantControl.value = variant?.id || '';
        status.textContent = '';
        form.querySelectorAll('[data-pdp-option]').forEach(field => {
          field.querySelector('[data-pdp-selected-option]').textContent = field.querySelector('input:checked')?.value || '';
        });
        if (!variant) {
          root.querySelector('[data-pdp-price]').textContent = '';
          root.querySelector('[data-pdp-compare]').hidden = true;
          const savings = root.querySelector('[data-pdp-savings]');
          if (savings) savings.hidden = true;
          return;
        }
        root.querySelector('[data-pdp-price]').textContent = variant.price;
        const compare = root.querySelector('[data-pdp-compare]');
        compare.textContent = variant.compare;
        compare.hidden = !variant.compare;
        if (quantity) {
          const rule = variant.quantityRule || {};
          const min = Number(rule.min) || 1;
          const step = Number(rule.increment) || 1;
          quantity.min = min;
          quantity.step = step;
          quantity.max = rule.max || '';
          const count = Math.max(min, Number(quantity.value) || min);
          quantity.value = Math.min(Number(rule.max) || Infinity, min + Math.floor((count - min) / step) * step);
        }
        const savings = root.querySelector('[data-pdp-savings]');
        if (savings) { savings.textContent = variant.savings ? `Save ${variant.savings}` : ''; savings.hidden = !variant.savings; }
        const imageIndex = cftVariantMediaIndex(slides.map(slide => slide.dataset.pdpMediaId), variant.mediaId);
        if (imageIndex >= 0) showMedia(imageIndex);
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      };
      form.addEventListener('change', event => {
        if (event.target.closest('[data-pdp-option]')) updateVariant();
      });
      form.querySelectorAll('[data-pdp-quantity-step]').forEach(button => button.addEventListener('click', () => {
        if (!quantity || adding) return;
        const min = Number(quantity.min) || 1;
        const step = Number(quantity.step) || 1;
        const max = Number(quantity.max) || Infinity;
        quantity.value = Math.max(min, Math.min(max, (Number(quantity.value) || min) + Number(button.dataset.pdpQuantityStep) * step));
        quantity.dispatchEvent(new Event('change', { bubbles: true }));
      }));
      form.addEventListener('submit', async event => {
        if (event.submitter !== buy) return;
        event.preventDefault();
        const variant = selectedVariant();
        if (adding || cftPurchaseState(data, variant).disabled) return;
        if (quantity && !quantity.checkValidity()) { quantity.reportValidity(); return; }
        const count = quantity ? Number(quantity.value) : 1;
        if (!Number.isInteger(count) || count < 1) return;
        adding = true;
        updateBuy();
        status.textContent = '';
        try {
          const base = window.Shopify?.routes?.root || '/';
          const response = await fetch(`${base}cart/add.js`, {
            method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: variant.id, quantity: count }] })
          });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || 'Please try again.');
          status.textContent = 'Added to your bag. ';
          const link = document.createElement('a');
          link.textContent = 'View bag';
          link.href = `${base}cart`;
          status.append(link);
        } catch (error) {
          status.textContent = error.message || 'Unable to add this item. Please try again.';
        } finally {
          adding = false;
          updateBuy();
        }
      });
      updateVariant();
      form.querySelector('[data-pdp-native-options]').hidden = true;
    }
    const sticky = root.querySelector('[data-pdp-sticky]');
    let observer;
    if (sticky) {
      const purchase = root.querySelector('[data-pdp-purchase]');
      observer = new IntersectionObserver(entries => {
        sticky.hidden = entries[0].isIntersecting || purchase.getBoundingClientRect().top > 0;
      });
      observer.observe(purchase);
      root.querySelector('[data-pdp-return]').addEventListener('click', () => {
        const form = purchase.querySelector('form');
        const buy = purchase.querySelector('[data-pdp-buy]');
        if (form && buy && !buy.disabled) { form.requestSubmit(buy); return; }
        purchase.scrollIntoView({ behavior: reduced() ? 'auto' : 'smooth', block: 'center' });
        purchase.querySelector('button')?.focus({ preventScroll: true });
      });
    }
    const resize = new ResizeObserver(() => { updateMedia(); if (tabs.length) selectTab(tabs.findIndex(t => t.getAttribute('aria-selected') === 'true')); });
    resize.observe(rail);
    root._pdpDisconnect = () => { observer?.disconnect(); resize.disconnect(); };
  };
  const scan = container => container.querySelectorAll('[data-cft-pdp]').forEach(initPdp);
  scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelector('[data-cft-pdp]')?._pdpDisconnect?.());
}
